"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TableHead;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _context = require("../context");
var _TableHeadField = _interopRequireDefault(require("./TableHeadField"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyles = (0, _makeStyles.default)(function (theme) {
  return (0, _extends2.default)({}, theme.mixins.table, {
    defaultBg: {},
    expandable: {},
    many: {},
    tableHead: {
      '&$defaultBg': {
        backgroundColor: theme.palette.background.default,
        borderBottom: "1px solid ".concat(theme.palette.background.paper)
      },
      '&$many': {
        [theme.breakpoints.down('md')]: {
          display: 'none'
        }
      },
      backgroundColor: theme.palette.background.paper,
      borderBottom: "1px solid ".concat(theme.palette.background.default),
      display: 'flex',
      position: function position(_ref) {
        var sticky = _ref.sticky;
        return sticky ? 'sticky' : 'inherit';
      },
      top: 64,
      zIndex: 1,
      [theme.breakpoints.down('md')]: {
        top: 56
      }
    },
    tableHeadCell: {
      '& > a:hover': {
        backgroundColor: theme.palette.action.hover
      },
      '&$expandable': {
        flex: "0 0 ".concat(theme.spacing(8)),
        paddingRight: theme.spacing(2)
      },
      '&$many': {
        [theme.breakpoints.down('md')]: {
          display: 'block',
          minWidth: '100%'
        },
        '& $tableHeadCellAction': {
          [theme.breakpoints.down('md')]: {
            padding: "10px ".concat(theme.spacing(2))
          }
        }
      },
      '&$reorder': {
        padding: theme.spacing(0, 0, 0, 2)
      },
      flex: '1 1 0',
      minWidth: 0,
      overflow: 'hidden',
      overflowWrap: 'break-word',
      textAlign: 'left',
      verticalAlign: 'middle'
    },
    tableHeadCellAction: {
      '&[disabled]': {
        color: theme.palette.text.disabled
      },
      alignItems: 'center',
      border: 'none',
      borderRadius: 0,
      color: theme.palette.text.secondary,
      display: 'flex',
      flexDirection: 'row',
      fontSize: 12,
      fontWeight: 400,
      height: 40,
      justifyContent: 'left',
      lineHeight: '12px',
      margin: 0,
      minWidth: 0,
      padding: '0 5px',
      textAlign: 'left',
      textTransform: 'none',
      verticalAlign: 'middle'
    },
    tableHeadCellActionText: {
      minWidth: 0
    },
    tableHeadRow: {
      display: 'flex',
      flex: '1 1 auto',
      padding: theme.spacing(0, 2)
    },
    virtualized: {
      '& $tableHeadRow': {
        padding: theme.spacing(0, 0, 0, 2)
      }
    }
  });
});
function TableHead(_ref2) {
  var id = _ref2.id;
  var _useContext = (0, _react.useContext)(_context.TableHeadContext),
    _useContext$classes = _useContext.classes,
    classes = _useContext$classes === void 0 ? {
      tableHead: null,
      tableHeadCell: null,
      tableHeadCellAction: null,
      tableHeadRow: null
    } : _useContext$classes,
    dense = _useContext.dense,
    expandableField = _useContext.expandableField,
    _useContext$fields = _useContext.fields,
    fields = _useContext$fields === void 0 ? [] : _useContext$fields,
    headerBgColorDefault = _useContext.headerBgColorDefault,
    reorderable = _useContext.reorderable,
    _useContext$search = _useContext.search,
    search = _useContext$search === void 0 ? {
      orderBy: ''
    } : _useContext$search,
    _useContext$sticky = _useContext.sticky,
    sticky = _useContext$sticky === void 0 ? true : _useContext$sticky,
    _useContext$sorting = _useContext.sorting,
    sorting = _useContext$sorting === void 0 ? true : _useContext$sorting,
    translationKeyRoot = _useContext.translationKeyRoot,
    virtualized = _useContext.virtualized;
  var styles = useStyles({
    sticky
  });
  var sortings = search.orderBy.split(',').map(function (a) {
    return a.split(':');
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      [styles.dense]: dense,
      [styles.many]: fields.length > 2,
      [styles.defaultBg]: headerBgColorDefault,
      [styles.virtualized]: virtualized
    }, styles.tableHead, classes.tableHead),
    id: id
  }, reorderable && /*#__PURE__*/_react.default.createElement(_TableHeadField.default, {
    classes: {
      tableHeadCell: (0, _classnames.default)(styles.tableHeadCell, styles.reorder, classes.tableHeadCell),
      tableHeadCellAction: (0, _classnames.default)(styles.tableHeadCellAction, classes.tableHeadCellAction),
      tableHeadCellActionText: styles.tableHeadCellActionText
    },
    id: "".concat(id, "ReorderField"),
    translationKey: "reorder",
    translationKeyRoot: translationKeyRoot
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(styles.tableHeadRow, classes.tableHeadRow)
  }, fields.map(function (field) {
    return /*#__PURE__*/_react.default.createElement(_TableHeadField.default, {
      key: field.orderBy || field.fieldKey || field.fieldName,
      classes: {
        tableHeadCell: (0, _classnames.default)(styles.tableHeadCell, styles[field.type || field.fieldName], classes.tableHeadCell),
        tableHeadCellAction: (0, _classnames.default)(styles.tableHeadCellAction, classes.tableHeadCellAction),
        tableHeadCellActionText: styles.tableHeadCellActionText
      },
      icon: field.icon || '',
      id: "".concat(id).concat(field.orderBy || field.fieldKey || field.fieldName),
      many: fields.length > 2,
      search: search,
      sorting: sorting && typeof field.sorting === 'undefined' || field.sorting === true,
      sortings: sortings,
      sortKey: field.orderBy || field.fieldName,
      style: field.style,
      translationKey: field.translationKey,
      translationKeyRoot: translationKeyRoot,
      type: field.type
    });
  })), expandableField && /*#__PURE__*/_react.default.createElement(_TableHeadField.default, {
    classes: {
      tableHeadCell: (0, _classnames.default)(styles.tableHeadCell, styles.expandable, classes.tableHeadCell),
      tableHeadCellAction: (0, _classnames.default)(styles.tableHeadCellAction, classes.tableHeadCellAction),
      tableHeadCellActionText: styles.tableHeadCellActionText
    },
    id: "".concat(id, "ExpandableField"),
    translationKey: expandableField.translationKey || 'more',
    translationKeyRoot: translationKeyRoot
  }));
}